export const APIRoutes = {
  DRAFT_MODE: {
    DISABLE: '/api/draft-mode/disable',
    ENABLE: '/api/draft-mode/enable'
  }
} as const

export type APIRoutes = typeof APIRoutes
export type APIRoutePaths = {
  [K in keyof typeof APIRoutes]: (typeof APIRoutes)[K] extends Record<string, string>
    ? (typeof APIRoutes)[K][keyof (typeof APIRoutes)[K]]
    : (typeof APIRoutes)[K]
}[keyof typeof APIRoutes]

export const ApiErrorType = {
  NOT_FOUND: 'NOT_FOUND',
  SERVER_ERROR: 'SERVER_ERROR',
  API_UNAVAILABLE: 'API_UNAVAILABLE',
  API_RATE_LIMIT: 'API_RATE_LIMIT'
} as const
export type ApiErrorType = keyof typeof ApiErrorType

export interface ApiErrorConfig {
  statusCode: number
  statusMessage: string
  message: string
  fatal?: boolean
  retryable?: boolean
}
